<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择GPS费"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
      :disabled="disabled"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  gpsList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    disabled: { // 禁用状态
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'id',
      searchBoxDataTmpl: {
        form: [
          { // 失效时间
            label: '失效时间',
            value: 'serviveLoseDate',
            type: 'date',
            default: [],
            placeholder: '请选择失效时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '套装类型',
            value: 'suitType',
            type: 'select',
            placeholder: '请选择套装类型',
            options: [
              {
                label: '电子眼',
                value: 1,
              },
              {
                label: '现场单',
                value: 2,
              },
            ],
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号',
        },
        {
          prop: 'suitTypeName',
          label: '套装类型',
        },
        {
          prop: 'serviveLoseDate',
          label: '服务失效日期',
        },
        {
          prop: 'equipmentNumber',
          label: '设备号',
        },
        {
          prop: 'oilWearEquoipmentBrand',
          label: '油耗设备品牌',
        },
        {
          prop: 'gpsEquoipmentBrand',
          label: '定位设备品牌',
        },
        {
          prop: 'oilWearEquoipmentModel',
          label: '油耗设备型号',
        },
        {
          prop: 'gpsEquoipmentModel',
          label: '定位设备型号',
        },
        {
          prop: 'oilWearEquoipmentNumber',
          label: '油耗设备号',
        },
        {
          prop: 'gpsEquoipmentNumber',
          label: '定位设备号',
        },
        {
          prop: 'suitFeeDouble',
          label: '套装费用',
        },
      ],
    };
  },
  methods: {
    getListApi: gpsList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      if (searchBoxData.serviveLoseDate[0]) {
        searchBoxData.serviveLoseDateBegin = this.formatDate(searchBoxData.serviveLoseDate[0], 1);
        searchBoxData.serviveLoseDateEnd = this.formatDate(searchBoxData.serviveLoseDate[1], 1);
      }
      delete searchBoxData.violationTime;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
